import React from 'react';
import { motion } from 'framer-motion';

const milestones = [
  {
    year: '2024',
    title: 'Solutions21 Founded',
    description: 'Incubated by the Expo City Dubai Technology team with a vision to push the boundaries of digital transformation.'
  },
  {
    year: '2023',
    title: 'COP28',
    description: 'Facilitated 100,000+ global leaders with real-time data & operational excellence.'
  },
  {
    year: '2022',
    title: 'Expo City Dubai',
    description: 'Built a digital ecosystem enhancing collaboration for businesses & tenants.'
  },
  {
    year: '2021',
    title: 'Expo 2020 Dubai',
    description: 'Powered visitor engagement for 24M+ attendees with seamless technology.'
  }
];

const images = [
  'https://images.ctfassets.net/r2cfrvo3y08m/2cOCtNN4XHtNjwLCu6FNt5/823919eed47f195f99d027e8f41b8034/Attraction_Hero_Al_Wasl_Pavilion1440x900.png',
  'https://images.ctfassets.net/r2cfrvo3y08m/1PvjWqT6FtRWBszV5QTSpN/1283ce692ec4afc5a0dd01d858b3fd47/Business_page_header-min.png?w=2880'
];

const OurStory = () => {
  const [currentImage, setCurrentImage] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-16 md:py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Left Column - Timeline */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="h-full"
          >
            <h2 className="text-3xl md:text-4xl font-display font-semibold text-white mb-8">
              Our Story – From Expo City Dubai to the World
            </h2>
            <div className="space-y-8">
              {milestones.map((milestone, index) => (
                <motion.div
                  key={milestone.year}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  className="relative pl-8 border-l-2 border-accent/30 pb-8 last:pb-0"
                >
                  <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-accent" />
                  <span className="text-accent font-semibold">{milestone.year}</span>
                  <h3 className="text-xl font-semibold text-white mt-2 mb-2">
                    {milestone.title}
                  </h3>
                  <p className="text-gray-400">
                    {milestone.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right Column - Image Carousel */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:sticky lg:top-24"
          >
            <div className="relative h-[600px] rounded-xl overflow-hidden shadow-2xl">
              {images.map((image, index) => (
                <motion.div
                  key={image}
                  initial={{ opacity: 0 }}
                  animate={{ 
                    opacity: currentImage === index ? 1 : 0
                  }}
                  transition={{
                    duration: 1,
                    ease: "easeInOut"
                  }}
                  className="absolute inset-0"
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" />
                  <motion.img
                    src={image}
                    alt="Our journey"
                    className="w-full h-full object-cover"
                    initial={{ scale: 1.1 }}
                    animate={{ 
                      scale: currentImage === index ? 1 : 1.1
                    }}
                    transition={{
                      duration: 6,
                      ease: "easeOut"
                    }}
                  />
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;